import { render, staticRenderFns } from "./CRUDTableGender.vue?vue&type=template&id=6f1cc6b4"
import script from "./CRUDTableGender.vue?vue&type=script&lang=js"
export * from "./CRUDTableGender.vue?vue&type=script&lang=js"
import style0 from "./CRUDTableGender.vue?vue&type=style&index=0&id=6f1cc6b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports